<template>
  <div class="operation">
    <div v-for="(item, index) in layerData" class="layer" :class="{
      'layer-style1': item.state === 1,
      'layer-style2': item.state === 2,
      'layer-style3': !item.show,  // 可以结合其他条件
    }" :key="index" @click="showLayer(item)">
      <img :src="item.img" class="layer-icon" />
      <span class="layer-text">{{ item.text }}</span>
      <span class="layer-value">{{ item.value }}</span>
    </div>
  </div>
</template>

<script>
import waterMeterIcon1 from '@/assets/bigusers/largeScreen/waterMeterIcon1.png'
import waterMeterIcon2 from '@/assets/bigusers/largeScreen/waterMeterIcon2.png'
import waterMeterIcon3 from '@/assets/bigusers/largeScreen/waterMeterIcon3.png'
import waterMeterIcon4 from '@/assets/bigusers/largeScreen/waterMeterIcon4.png'
import waterMeterIcon5 from '@/assets/bigusers/largeScreen/waterMeterIcon5.png'
import waterMeterIcon6 from '@/assets/bigusers/largeScreen/waterMeterIcon6.png'

export default {
  name: 'layerOperationMap',
  data () {
    return {
      layerUrl: '/smart-water-major-users/major/users/user/user/count/watermetertype',
      layerData: [
        {
          img: waterMeterIcon1,
          initialImg: waterMeterIcon1,
          hideImg: waterMeterIcon6,
          text: '正常机械表',
          value: 0,
          type: 1,
          show: true,
          state: 1
        }, {
          img: waterMeterIcon2,
          initialImg: waterMeterIcon2,
          hideImg: waterMeterIcon5,
          text: '正常远程表',
          value: 0,
          type: 2,
          show: true,
          state: 1
        },
        {
          img: waterMeterIcon3,
          initialImg: waterMeterIcon3,
          hideImg: waterMeterIcon6,
          text: '异常机械表',
          value: 0,
          type: 3,
          show: true,
          state: 2
        },
        {
          img: waterMeterIcon4,
          initialImg: waterMeterIcon4,
          hideImg: waterMeterIcon5,
          text: '异常远程表',
          value: 0,
          type: 4,
          show: true,
          state: 2
        },
      ],
    }
  },
  mounted () {
    this.getLayerData();
  },
  methods: {
    showLayer (item) {
      item.show = !item.show
      if (item.show) {
        item.img = item.initialImg
      } else {
        item.img = item.hideImg
      }
      this.$emit('showLayer', item);
    },
    getLayerData () {
      this.$http.get(this.layerUrl).then((res) => {
        res.data.forEach(element => {
          let index =
            element.normalAbnormal == 1 && element.waterMeterType == 1 ? 0 :
              element.normalAbnormal == 1 && element.waterMeterType == 2 ? 1 :
                element.normalAbnormal == 2 && element.waterMeterType == 1 ? 2 : 3;
          this.layerData[index].value = element.countWaterMeterType;
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.operation {
  background-image: url(~@/assets/bigusers/largeScreen/layerOperationMapBg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 149px;
  height: 160px;
}

.layer {
  width: 149px;
  height: 40px;
  text-align: center;
  align-items: center;
  line-height: 40px;
  padding: 0 10px;
  box-sizing: border-box;
  cursor: pointer;

  &-icon {
    width: 13px;
    /* 统一图标大小 */
    height: 17px;
    margin-right: 8px;
    /* 图标和文字间距 */
    flex-shrink: 0;
    /* 防止图标被压缩 */
  }

  &-text {
    color: white;
    font-size: 12px;
    font-weight: bold;
    flex-grow: 1;
    /* 让文本占据剩余空间 */
    text-align: left;
    white-space: nowrap;
    /* 防止文字换行 */
    overflow: hidden;
    text-overflow: ellipsis;
    /* 文字过长显示省略号 */
  }

  &-value {
    color: white;
    font-size: 12px;
    width: 40px;
    display: inline-block;
    /* 数值和文字间距 */
    flex-shrink: 0;
    /* 防止数值被压缩 */
  }
}



.layer-style1 {
  background: url(~@/assets/bigusers/largeScreen/layer1.png) no-repeat;
  background-size: 100% 100%;
}

.layer-style2 {
  background: url(~@/assets/bigusers/largeScreen/layer2.png) no-repeat;
  background-size: 100% 100%;
}

.layer-style3 {
  background: url(~@/assets/bigusers/largeScreen/layer3.png) no-repeat;
  background-size: 100% 100%;
}
</style>